import React, { FC } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams } from 'react-router-dom'

import { Stack, GuildMetadata } from '@components'

import { GuildPresentationsScreenUpcomingPresentationsSection } from './GuildPresentationsScreenUpcomingPresentationsSection'
import { GuildPresentationsScreenOtherPresentationsSection } from './GuildPresentationsScreenOtherPresentationsSection'

import { GuildPresentationsScreenQuery } from './__generated__/GuildPresentationsScreenQuery.graphql'

export const GuildPresentationsScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<GuildPresentationsScreenQuery>(
    graphql`
      query GuildPresentationsScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name

            ...GuildMetadata_guild
            ...GuildPresentationsScreenUpcomingPresentationsSection_guild
            ...GuildPresentationsScreenOtherPresentationsSection_guild
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return (
    <>
      <GuildMetadata
        guild={data.nodeBySlugId}
        title={`${data.nodeBySlugId.name} Presentations`}
      />

      <Stack gap={5}>
        <GuildPresentationsScreenUpcomingPresentationsSection
          guild={data.nodeBySlugId}
        />

        <GuildPresentationsScreenOtherPresentationsSection
          guild={data.nodeBySlugId}
        />
      </Stack>
    </>
  )
}

export default GuildPresentationsScreen
